import { computed, ref } from 'vue';
import type { PassengerKey } from '@aviata/booking-data';

import { mappedPassengersLib } from '@/entities/passenger-with-baggages';
import type {
  ExtendedBaggage,
  PassengerWithBaggage,
  ExtendedFlight,
} from '@/entities/passenger-with-baggages';

const getUpdatedFlights = (
  flights: ExtendedFlight[],
  flightId: number,
  baggages: ExtendedBaggage[],
) => {
  return flights.map(flight => {
    if (flightId === flight.id) {
      return { ...flight, availableBaggages: baggages };
    }
    return flight;
  });
};

const useDraftPassengers = (mappedPassengers: PassengerWithBaggage[]) => {
  const currentState = ref<PassengerWithBaggage[]>(mappedPassengers);

  const onUpdate = (
    passengerKey: PassengerKey,
    flightId: number,
    baggages: ExtendedBaggage[],
  ) => {
    currentState.value = currentState.value.map(passenger => {
      if (passenger.key === passengerKey) {
        return {
          ...passenger,
          flightsWithBaggages: getUpdatedFlights(
            passenger.flightsWithBaggages,
            flightId,
            baggages,
          ),
        };
      }
      return passenger;
    });
  };

  const totalPrice = computed(() =>
    mappedPassengersLib.getTotalPrice(currentState.value),
  );
  const totalOriginalPrice = computed(() =>
    mappedPassengersLib.getTotalOriginalPrice(currentState.value),
  );

  return {
    currentState,
    totalPrice,
    totalOriginalPrice,
    onUpdate,
  };
};

export const ancillariesModel = {
  useDraftPassengers,
};
